export const AUTH = {
  MIN_PASSWORD_CHARACTERS: 6,
  MAX_PASSWORD_CHARACTERS: 100,
};
